export default __webpack_public_path__ + "static/media/cover_ex_libris.3650dcd5.png";